import React from "react"
import { LoaderMedium } from "../../../components/Loaders"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Tooltip } from "primereact/tooltip"
import { capitalizeFirstLetter } from "../Utils"
import { Button } from "primereact/button"

import trcss from "../../../styles/Telerecovery.module.css"

export default function CallHistory(props) {

  if (!props.callHistory || props.loading) return <LoaderMedium />

  const errorTemplate = (rowData, { rowIndex }) => {
    if (rowData.errorMessage) {
      return <>
        <i id={`error_icon_${rowIndex}`}
          className="pi pi-exclamation-circle"
          style={{ color: 'red' }}
        />
        <Tooltip target={`#error_icon_${rowIndex}`} className="custom-tooltip" position='bottom'>
          <span>
            ({rowData.errorCode || "0000"}) {capitalizeFirstLetter(rowData.errorMessage)}
          </span>
        </Tooltip>
      </>
    }
  }

  return (
    <>
      <div className={trcss.historyHeader}>
        <div className={trcss.historyHeaderText}>
          Call History
        </div>
        <Button
          icon="pi pi-refresh"
          className={trcss.historyRefreshBtn}
          onClick={props.refresh}
        />
      </div>

      <DataTable
        value={props.callHistory}
        style={{
          fontSize: "75%",
        }}
      >
        <Column field="date" header="Date" />
        <Column field="time" header="Time" />
        <Column field="direction" header="Direction" />
        <Column field="duration" header="Duration" />
        <Column header="Error" body={errorTemplate} />
      </DataTable>
    </>
  )
}
